<template>
  <nuxt-link
    class="nav-button flex flex-column flex-align-center"
    :to="routeUrl"
  >
    <component
      :is="icon"
      class="icon"
    />
    <div class="title">
      {{ buttonText }}
    </div>
  </nuxt-link>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    isPartner?: boolean
    routeUrl?: string
    currentPath?: string
    purchaseButtonSrc?: string
    activateTrigger?: boolean
    purchaseTrigger?: boolean
    buttonText?: string
    icon?: string
  }>(),
  {
    isPartner: false,
    routeUrl: '',
    currentPath: '',
    purchaseButtonSrc: '',
    activateTrigger: false,
    purchaseTrigger: false,
    buttonText: '',
    icon: ''
  }
)

const color = computed(() => {
  return props.activateTrigger ? '#212121' : '#BDBDBD'
})
</script>

<style lang="scss" scoped>
.nav-button {
  width: 100%;
  height: 100%;
  padding: 11px 0;
  .title {
    color: v-bind(color);
    @include footnote2-medium;
  }
  .icon {
    width: 24px;
    height: 24px;
    color: v-bind(color);
    margin-bottom: 4px;
  }
}
</style>
